import { Map } from "immutable";

import {
  SectionStat,
  sectionStatSelectors,
  sectionStatsSelectors
} from "seneca-common/features/stats/state";

type Arguments = {
  sectionStats: Map<string, SectionStat>;
  totalSections: number;
};

type AfterSessionArguments = Arguments & {
  sessionSectionId: string;
  sessionScore: number;
};

export function calculateAverageOfSectionScores({
  sectionStats,
  totalSections
}: Arguments): number {
  const sumScore = sectionStats.reduce(
    (sum, sectionStat) => sum + sectionStatSelectors.getBestScore(sectionStat)!,
    0
  );
  return sumScore / totalSections;
}

/**
 * This selector is used to calculate the course score at the end of a session,
 * before the store has been updated with the latest section stats.
 *
 * This logic should probably be moved to the reducer so the course stat and,
 * section stat can be updated at the same time - but this requires a refactor.
 */
export function calculateAverageOfSectionScoresAfterSession({
  sectionStats,
  totalSections,
  sessionSectionId,
  sessionScore
}: AfterSessionArguments): number {
  const currentSectionBestScore = sectionStatsSelectors.hasSectionStat(
    sectionStats,
    sessionSectionId
  )
    ? Math.max(
        sessionScore,
        sectionStatsSelectors.getBestScore(sectionStats, sessionSectionId)
      )
    : sessionScore;
  const sumScore = sectionStats.reduce((sum, sectionStat) => {
    if (sectionStatSelectors.getSectionId(sectionStat) === sessionSectionId) {
      return sum;
    } else {
      return sum + sectionStatSelectors.getBestScore(sectionStat)!;
    }
  }, currentSectionBestScore);
  return sumScore / totalSections;
}
